module.exports = ".well {\n  overflow-wrap: break-word; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal-edit/popups/popups.component.scss
// module id = ./src/app/modal-edit/popups/popups.component.scss
// module chunks = main